import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { Reveal, SectionLabel } from './Reveal';
import { IMAGES } from '../../data/content';

export const Concept = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const scale = useTransform(scrollYProgress, [0, 1], [1.2, 1]);

  return (
    <section
      id="concept"
      ref={ref}
      data-testid="concept-section"
      className="relative overflow-hidden border-t border-white/5 bg-navy-950"
    >
      <motion.div style={{ scale }} className="absolute inset-0">
        <img
          src={IMAGES.concept}
          alt=""
          className="h-full w-full object-cover opacity-30"
        />
      </motion.div>
      <div className="absolute inset-0 bg-navy-950/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/50 to-navy-950/80" />

      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8 py-28 lg:py-40">
        <div className="max-w-4xl">
          <Reveal>
            <SectionLabel>The Concept</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 font-serif text-3xl leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl text-balance">
              We believe the next century of healthcare will be defined not only
              by discovery, but by the{' '}
              <span className="text-gold">institutions built to sustain it.</span>
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-10 max-w-2xl text-base leading-relaxed text-slate-300 lg:text-lg">
              London Biotech International was conceived to answer a global
              question: how do nations build the physical, legal and clinical
              foundations for world-class life sciences? Our concept is a single
              accountable vehicle — carrying a mandate from ambition through to
              operational delivery, anywhere in the world.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
